// action
import {
    DELETE_MODULE,
    DELETE_MODULE_FAIL,
    DELETE_MODULE_SUCCESS,
    DELETE_MODULE_RESET
} from '../action/deleteModuleAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case DELETE_MODULE:
            return {
                ...state,
                apiState: "loading"
            }
        case DELETE_MODULE_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case DELETE_MODULE_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case DELETE_MODULE_RESET:
            return initialState
        default:
            return state
    }
}